module.exports = __webpack_public_path__ + "static/media/Icon ionic-md-arrow-dropdown.121c0e03.svg";